import * as React from "react";
import "./Footer.scss";
import {Multicolumns} from "./Layouts/Multicolumns";

const Layouts = {
  'multicolumns': Multicolumns
}

export const Footer = ({ shop, globals, settings, links, type }) => {
  const LayoutComponent = Layouts[type] || Multicolumns;

  return (
      <div className={`header-container ${settings.container_type}`}>
        <LayoutComponent
            globals={globals}
            shop={shop}
            settings={settings}
            links={links}
            type={type}
        />
      </div>
  );
};
